export default {
   // user settings data 
   intiSettings(state, settings = null) {
      state.settings = modifyColumnNames(settings);
   },

}